import { render, staticRenderFns } from "./CarouselOffer.vue?vue&type=template&id=b8ed8ae8"
import script from "./CarouselOffer.vue?vue&type=script&lang=js"
export * from "./CarouselOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports